import React from 'react';
import './frame-builder.scss';
import {observer} from 'mobx-react';
import {Inches, RenderV2Object} from './render-v2-d';
import {Moulding} from './moulding/moulding';
import {InnerContent} from './inner-content/inner-content';
import {CustomItem} from './custom-item/custom-item';
import {FrameOld} from '../../product/rendering/frame-old';
import {FrameNone} from '../../product/rendering/frame-none';
import {ProductCustomizationState} from '../../product/rendering/render.def';
import {FrameBuilderStore} from './frame-builder-store';

type Props = {
    pcs: ProductCustomizationState;
    frame: RenderV2Object;
};

export const FrameBuilder = observer(({frame, pcs}: Props) => {
    if (pcs.CustomizationMethodID === 0) return <FrameNone pcs={pcs} />;
    if (pcs.CustomizationMethodID === 1) return <FrameOld pcs={pcs} />;

    const store = new FrameBuilderStore(frame);
    const {frameWidth, frameHeight, contentWidth, contentHeight, maxCols, getGap, inchToPx} = store;

    store.DPI = pcs.DPI;

    return (
        <div id="frame-builder-container">
            <div
                id="frame-builder"
                style={{
                    width: inchToPx(frameWidth),
                    height: inchToPx(frameHeight),
                    background: frame.mat1ImageURL ? '' : frame.mat1Color,
                    backgroundImage: frame.mat1ImageURL ? `url("${frame.mat1ImageURL}")` : '',
                }}
            >
                <Moulding
                    height={contentHeight}
                    width={contentWidth}
                    store={store}
                />

                <InnerContent
                    maxCols={maxCols}
                    store={store}
                    width={contentWidth}
                    height={contentHeight}
                    columnGap={getGap('gapRight', 'first') as Inches}
                />

                <CustomItem store={store} />
            </div>
        </div>
    );
});
